/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Forced_SubtitlesInputs */

const en_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forced Subtitles`)
};

const fr_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titres forcés`)
};

const de_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erzwungene Untertitel`)
};

const it_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitoli forzati`)
};

const ru_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принудительные субтитлы`)
};

const es_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulos forzados`)
};

const zh_cn2_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`强制字幕`)
};

const ja_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強制字幕`)
};

const hi_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जबरन उपशीर्षक`)
};

const pt_pt2_subtitle_export_forced_subtitles = /** @type {(inputs: Subtitle_Export_Forced_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas forçadas`)
};

/**
* | output |
* | --- |
* | "Forced Subtitles" |
*
* @param {Subtitle_Export_Forced_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_forced_subtitles = /** @type {((inputs?: Subtitle_Export_Forced_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Forced_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_forced_subtitles(inputs)
	if (locale === "de") return de_subtitle_export_forced_subtitles(inputs)
	if (locale === "it") return it_subtitle_export_forced_subtitles(inputs)
	if (locale === "ru") return ru_subtitle_export_forced_subtitles(inputs)
	if (locale === "es") return es_subtitle_export_forced_subtitles(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_forced_subtitles(inputs)
	if (locale === "ja") return ja_subtitle_export_forced_subtitles(inputs)
	if (locale === "hi") return hi_subtitle_export_forced_subtitles(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_forced_subtitles(inputs)
	return en_subtitle_export_forced_subtitles(inputs)
});